// Model.js
// -----------------------
// @module Case
define("NVT.MyRegisterColleague.MyRegisterColleague.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/MyRegisterColleague/SuiteScript2/MyRegisterColleague.Service.ss"
            ),
            true
        )
});
});
